import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.88636 2C2.57047 2 1.5 3.07047 1.5 4.38636V4.41542C1.5 5.72032 2.55266 6.78388 3.85343 6.80156V14.6136C3.85343 15.9295 4.9239 17 6.2398 17H11.7893C13.1052 17 14.1756 15.9295 14.1756 14.6136C14.1756 14.2585 13.8877 13.9706 13.5325 13.9706C13.1774 13.9706 12.8895 14.2585 12.8895 14.6136C12.8895 15.2202 12.3959 15.7138 11.7893 15.7138H6.2398C5.6332 15.7138 5.13959 15.2202 5.13959 14.6136V3.28616H12.8895V11.7082C12.8895 12.0633 13.1774 12.3512 13.5325 12.3512C13.8877 12.3512 14.1756 12.0633 14.1756 11.7082V6.80099C15.463 6.768 16.5 5.71059 16.5 4.41542V4.38636C16.5 3.07047 15.4295 2 14.1136 2H3.88636ZM2.78616 4.38636C2.78616 3.79078 3.262 3.30412 3.85343 3.28664V5.51514C3.262 5.49766 2.78616 5.011 2.78616 4.41542V4.38636ZM14.1756 5.5139V3.28788C14.7535 3.32014 15.2138 3.80056 15.2138 4.38636V4.41542C15.2138 5.00122 14.7535 5.48164 14.1756 5.5139Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M9.02905 4.23722C8.67389 4.23722 8.38598 4.52513 8.38598 4.88029C8.38598 5.23546 8.67389 5.52337 9.02905 5.52337C9.38422 5.52337 9.67213 5.23546 9.67213 4.88029C9.67213 4.52513 9.38422 4.23722 9.02905 4.23722Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.15494 6.80372C7.66816 6.80372 6.45866 8.0132 6.45866 9.5C6.45866 10.9868 7.66816 12.1963 9.15494 12.1963C10.6417 12.1963 11.8512 10.9868 11.8512 9.5C11.8512 8.0132 10.6417 6.80372 9.15494 6.80372ZM7.65785 9.5C7.65785 8.72329 8.32628 8.08562 9.15494 8.08562C9.9836 8.08562 10.652 8.72329 10.652 9.5C10.652 10.2767 9.98363 10.9144 9.15494 10.9144C8.32628 10.9144 7.65785 10.2767 7.65785 9.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M9.02905 13.4766C8.67389 13.4766 8.38598 13.7645 8.38598 14.1197C8.38598 14.4749 8.67389 14.7628 9.02905 14.7628C9.38422 14.7628 9.67213 14.4749 9.67213 14.1197C9.67213 13.7645 9.38422 13.4766 9.02905 13.4766Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}